module.exports = __webpack_public_path__ + "img/fahrzeugschein.a2dcafe.jpg";